import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    namaKategori: Yup.string().required("Masukan nama kategori anggaran"),
  });
